"use client"

import { useState } from "react"
import { Plus, CalendarClock, Video, Copy } from "lucide-react";
const { createRoom } = require('../../model/createRoomAcs');

export function Home({ userId, adminLink, sellerLink, getLinkAfterCreateRoom }) {
  const [isCopied, setIsCopied] = useState(false)

  console.log("Admin Link:", adminLink);
  console.log("Seller Link:", sellerLink);
  console.log("User ID:", userId);

  const meetingOptions = [
    {
      title: "Join Meeting",
      subtitle: "Quick Access, Seamless Connection",
      icon: Plus,
      bgColor: "#0094ff",
      iconBgColor: "#0967aa",
      action: () => console.log("Join Meeting Clicked"),
    },
    {
      title: "Schedule Meeting",
      subtitle: "Plan Ahead, Stay Organized",
      icon: CalendarClock,
      bgColor: "#094ee4",
      iconBgColor: "#0d3ca3",
      action: () => console.log("Schedule Meeting Clicked"),

    },
    {
      title: "Host Meeting",
      subtitle: "Your Meeting, Your Control",
      icon: Video,
      bgColor: "#f26d21",
      iconBgColor: "#bc4501",
      action: () => createRoom(userId, getLinkAfterCreateRoom),
    },
  ]

  const handleCopy = () => {
    if (sellerLink) {
      navigator.clipboard
        .writeText(sellerLink)
        .then(() => {
          setIsCopied(true)
          setTimeout(() => setIsCopied(false), 2000)
        })
        .catch((err) => {
          console.error("Failed to copy: ", err)
        })
    }
  }

  return (
    <div>
      <h2 style={{ marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>Meetings</h2>
      <div className="meeting-options">
        {meetingOptions.map((option, index) => (
          <div
            key={index}
            className="meeting-option"
            style={{ backgroundColor: option.bgColor }}
            onClick={option.action}
          >
            <div className="option-icon" style={{ backgroundColor: option.iconBgColor }}>
              <option.icon />
            </div>
            <div className="option-content">
              <h3>{option.title}</h3>
              <p>{option.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      {adminLink && sellerLink && (
        <div className="meeting-links">
          <h2>Meeting Links</h2>
          <div className="link-card">
            <div className="link-info">
              <h3>Admin Link</h3>
              <p>{adminLink}</p>
            </div>
            <button className="copy-button" onClick={() => window.open(adminLink, "_blank", "noreferrer")}>
              Open
            </button>
          </div>

          <div className="link-card">
            <div className="link-info">
              <h3>User Link</h3>
              <p>{sellerLink}</p>
            </div>
            <button className="copy-button" onClick={handleCopy}>
              <Copy />
              {isCopied ? "Copied!" : "Copy Link"}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
